import { render, staticRenderFns } from "./ProjectTemplateManagement.vue?vue&type=template&id=0cd84290&scoped=true"
import script from "./ProjectTemplateManagement.vue?vue&type=script&lang=js"
export * from "./ProjectTemplateManagement.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplateManagement.vue?vue&type=style&index=0&id=0cd84290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd84290",
  null
  
)

export default component.exports